import { render, staticRenderFns } from "./Partners.vue?vue&type=template&id=68e5f5bb&scoped=true&"
import script from "./Partners.vue?vue&type=script&lang=js&"
export * from "./Partners.vue?vue&type=script&lang=js&"
import style0 from "./Partners.vue?vue&type=style&index=0&id=68e5f5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5f5bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68e5f5bb')) {
      api.createRecord('68e5f5bb', component.options)
    } else {
      api.reload('68e5f5bb', component.options)
    }
    module.hot.accept("./Partners.vue?vue&type=template&id=68e5f5bb&scoped=true&", function () {
      api.rerender('68e5f5bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/Partners.vue"
export default component.exports